import { createFileRoute } from "@tanstack/react-router"

import { requireSystemUser } from "@/lib/require-system-user"
import SystemSettingsPage from "@/routes/_layout/settings/-components/system-settings-page"

export const Route = createFileRoute("/_layout/settings/system")({
  staticData: { breadcrumb: "System Settings" },
  beforeLoad: ({ context: { queryClient } }) =>
    requireSystemUser(queryClient, "/"),
  component: SystemSettingsPage,
})
